import { IDeleteContratoServicoUseCase } from "../../../presentation/useCases/delete/delete_contrato_service_use_case";
import { IDeleteContratoUseCase } from "../../../presentation/useCases/delete/delete_contrato_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// DeleteContratoServicoUseCase

export class DeleteContratoServicoUseCase implements IDeleteContratoServicoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async deleteContratoServico(IdContratoServico: number): Promise<void> {
    await this.repository.deleteContratoServico(IdContratoServico);
  }
}
